import { Button } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 70%;
    gap: 32px;
`

export const ConsultReceivementButton = styled(Button)`
  background: ${theme.colors.green2} !important;
`
